/**
 * @generated SignedSource<<b5a3c8d61bb02ae1e4e6117787aa5963>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetNoteSize = "TWO_X_ONE" | "TWO_X_TWO";
import { FragmentRefs } from "relay-runtime";
export type NoteEdit$data = {
  readonly id: string;
  readonly noteSize: WidgetNoteSize;
  readonly pages: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"NoteEditInfo_page" | "WidgetNoteCameraMode_widgetNotePage" | "WidgetNotePageImageMode_widgetNotePage" | "WidgetNoteTextModeAccessoryView_page" | "WidgetNoteTextModePage_widgetNotePage">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"NoteEditSharedInfo_widgetNote">;
  readonly " $fragmentType": "NoteEdit";
};
export type NoteEdit$key = {
  readonly " $data"?: NoteEdit$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteEdit">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteEdit",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NoteEditSharedInfo_widgetNote"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetNotePage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetNoteCameraMode_widgetNotePage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetNotePageImageMode_widgetNotePage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NoteEditInfo_page"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetNoteTextModePage_widgetNotePage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetNoteTextModeAccessoryView_page"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noteSize",
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "a3ad0bbc5628a533f9f5e319a54d06b2";

export default node;
